import { extractOcrDataRows, pickFirst } from '@/pages/demo/utils/demoOcrResultModel';

const trimToNull = (value: unknown): string | null => {
  if (value === null || value === undefined) return null;
  const text = String(value).trim();
  return text === '' ? null : text;
};

const numberToNullable = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const text = String(value).trim().replace(/,/g, '');
  if (!text) return null;
  const parsed = Number(text);
  return Number.isFinite(parsed) ? parsed : null;
};

export const buildDemoOcrPostProcessPayload = ({
  ocrResult,
  prescriptionYearMonth,
  source = 'admin-demo-post-process',
  mode = 'SUGGEST',
}: {
  ocrResult: unknown;
  prescriptionYearMonth: string;
  source?: string;
  mode?: string;
}) => {
  const rows = extractOcrDataRows(ocrResult).map((row, idx) => ({
    rowId:
      trimToNull(row?.rowId) ??
      trimToNull(row?.row_id) ??
      trimToNull(row?.id) ??
      trimToNull(row?.__demoRowKey) ??
      trimToNull(row?.key) ??
      `row-${idx + 1}`,
    rawDrugCode: trimToNull(pickFirst(row, ['rawDrugCode', 'drugCode', 'code'])),
    rawDrugName: trimToNull(pickFirst(row, ['rawDrugName', 'drugName', 'name'])),
    rawPharmaCompanyName: trimToNull(
      pickFirst(row, [
        'rawPharmaCompanyName',
        'pharmaCompanyName',
        'pharmaCompany',
        'manufacturerName',
        'pharmaceuticalCompanyName',
      ]),
    ),
    rawUnitPrice: numberToNullable(
      pickFirst(row, ['rawUnitPrice', 'unitPrice', 'price', 'drugPrice']),
    ),
    rawUsageAmount: numberToNullable(
      pickFirst(row, [
        'rawUsageAmount',
        'outHospitalQuantity',
        'outpatientUsageAmount',
        'outHouseQuantity',
        'outQuantity',
        'usageAmount',
      ]),
    ),
    rawClaimAmount: numberToNullable(
      pickFirst(row, [
        'rawClaimAmount',
        'totalAmount',
        'amount',
        'estimatedAmount',
        'sumAmount',
        'claimAmount',
      ]),
    ),
    rawInHouseUsageAmount: numberToNullable(
      pickFirst(row, [
        'rawInHouseUsageAmount',
        'inHospitalQuantity',
        'inHouseUsageAmount',
        'inHouseQuantity',
        'inQuantity',
      ]),
    ),
  }));

  return { prescriptionYearMonth, source, mode, rows };
};

export const indexPostProcessItemsByRowId = (response: { items?: Array<{ rowId?: string }> }) => {
  const items = Array.isArray(response?.items) ? response.items : [];
  return items.reduce<Record<string, (typeof items)[number]>>((acc, item) => {
    const key = trimToNull(item?.rowId);
    if (key) acc[key] = item;
    return acc;
  }, {});
};
